import type {CsRobotInfo} from '@px/streams/cs-robot';

declare global {
  interface Window {
    zE: any;
    zESettings: any;
  }
}

export const zeUtil = {
  init(lang = 'en', onload = null, robotInfo: CsRobotInfo = null) {
    if (window.zE || !robotInfo) {
      return;
    }
    const script = document.createElement('script');
    script.id = 'ze-snippet';
    script.src = '//static.zdassets.com/ekr/snippet.js?key=' + robotInfo.widget;
    script.defer = true;
    script.type = 'text/javascript';
    script.onload = function () {
      window.zE('messenger', 'hide');
      window.zE('messenger:on', 'close', function () {
        window.zE('messenger', 'hide');
      });
      onload();
      setLocale(lang);
    };
    document.head.appendChild(script);
    window.zESettings = {
      webWidget: {
        offset: {},
        chat: {
          connectOnPageLoad: false,
          prechatForm: {},
        },
      },
    };
    document.head.appendChild(script);
  },
  changeUserInfo(userInfo, tags) {
    if (userInfo.userId > 0) {
      setLocale(userInfo.lang);

      window.zE('messenger:set', 'conversationFields', {
        name: userInfo.nickName,
        email: userInfo.email,
      });
      window.zE('messenger:set', 'conversationTags', tags);
      return;
    }
  },
  async openChat() {
    window.zE('messenger', 'show');
    window.zE('messenger', 'open');
  },
  async hideChat() {
    window.zE('messenger', 'close');
  },
};

function setLocale(lang) {
  if (lang) {
    window.zE('messenger:set', 'locale', lang);
  }
}
